import Rest from '../Rest'

export default class BankDetailService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/bank_details'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
